var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btn-box", staticStyle: { display: "none" } },
    [
      _c(
        "el-button",
        {
          staticStyle: { "text-align": "center", width: "60%" },
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              return _vm.handleSubmit("formInline")
            },
          },
        },
        [_vm._v("确定")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }